import { CostingMethodEnum, ItemTypeEnum } from "@forgepoint/shared";
import type { CostingMethod, ItemType } from "@forgepoint/shared";

/** Display names for item types. */
export const ITEM_TYPE_LABELS: Record<ItemType, string> = {
  [ItemTypeEnum.MANUFACTURED]: "Manufactured",
  [ItemTypeEnum.PURCHASED]: "Purchased",
  [ItemTypeEnum.MATERIAL]: "Material",
};

/** Display names for costing methods. */
export const COSTING_METHOD_LABELS: Record<CostingMethod, string> = {
  [CostingMethodEnum.BOM]: "BOM",
  [CostingMethodEnum.UNIT_COST]: "Unit Cost",
};
